import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import './styles.scss';


SearchInput.propTypes = {
    title: PropTypes.string,
    path: PropTypes.string,
};

function SearchInput(props) {
    const { inputValue, onChange, onClick } = props;
    return (
        <div className="searchInput">
            <input type="text" value={inputValue} onChange={onChange}
                className="input" placeholder="请输入产品名称/产品型号">
            </input>
            <div className="searchIcon" onClick={onClick}></div>
        </div>
    );
}

export default SearchInput;